export default __webpack_public_path__ + "static/media/detail_two.19badba3.png";